import { mount } from "@vue/test-utils";
import Paso4 from "@/views/Paso4";

jest.mock("@/views/Paso4", () => ({
  ...jest.requireActual("@/views/Paso4"),
  __esModule: true,
  default: {
    email: "mockedValue@.com"
  }
}));

describe("Paso4 test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Paso4);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Paso4", () => {
    expect(wrapper).toBeDefined();
  });
});
